type IsClaimActionVisibleArgsType = {
  status: string;
  claimedById: string | null;
  currentUserId: string;
};

export const isClaimActionVisible = ({
  status,
  claimedById,
  currentUserId,
}: IsClaimActionVisibleArgsType): boolean =>
  status === 'OPEN' && (claimedById === null || claimedById !== currentUserId);
